import { Criteria } from '@openx/types/targeting/targetingValuesTypes.ts';
import { useTranslation } from 'react-i18next';

export function useGetDimensionLabels() {
  const { t } = useTranslation();

  const dimensionLabels = {
    [Criteria.ALL]: t('AND'),
    [Criteria.ANY]: t('OR'),
  };

  return { dimensionLabels };
}
